import DynamicSingleForm from "./DynamicSingleForm";

export { DynamicSingleForm };

export default DynamicSingleForm;
